var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharacterWonder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 338 621",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upper-body"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bust"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 139",
    d: "M255 445L75 445L75 286.134L107.553 261.375L221.079 260L255 286.134L255 445Z",
    fill: "#FEC7A9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 64",
    filter: "url(#filter0_d_435_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 328.771L120 294L165.5 328.771L210 294L255 328.771V446H75V328.771Z",
    fill: "#EFCC3C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 65",
    d: "M75 336.451L120 309L165.5 336.451L210 309L255 336.451V429H75V336.451Z",
    fill: "#F73308"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "legs"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 29",
    d: "M54.0008 605.939C54.0004 597.942 58.4926 591.397 64.1742 590.879H133.214C138.896 591.397 143.389 597.942 143.389 605.939C143.39 613.937 138.897 620.482 133.216 621H64.176C58.4943 620.482 54.0013 613.937 54.0008 605.939Z",
    fill: "#F73308"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 30",
    d: "M188.857 605.813C188.856 597.747 193.387 591.147 199.116 590.625H268.739C274.469 591.147 279 597.747 279 605.813C279.001 613.878 274.471 620.478 268.741 621.001H199.118C193.388 620.478 188.857 613.878 188.857 605.813Z",
    fill: "#F73308"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 66",
    x: 74,
    y: 483,
    width: 67,
    height: 102,
    rx: 5,
    fill: "#FEC7A9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 67",
    d: "M74 539H141V580C141 582.761 138.761 585 136 585H79C76.2386 585 74 582.761 74 580V539Z",
    fill: "#F73308"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 75",
    d: "M74 539H141V551H74V539Z",
    fill: "#EFCC3C"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 68",
    x: 188,
    y: 483,
    width: 67,
    height: 102,
    rx: 5,
    fill: "#FEC7A9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 69",
    d: "M188 539H255V580C255 582.761 252.761 585 250 585H193C190.239 585 188 582.761 188 580V539Z",
    fill: "#F73308"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 76",
    x: 188,
    y: 539,
    width: 67,
    height: 12,
    fill: "#EFCC3C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 74",
    filter: "url(#filter1_d_435_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74 446H255L264.5 502L163.5 517L65 502L74 446Z",
    fill: "#0B1345"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 140",
    d: "M273.657 160.188C298.957 163.578 302.752 195.354 270.283 202.981L273.657 160.188Z",
    fill: "#FEC7A9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 141",
    d: "M11.0536 186.819L35.3403 143.877H63.6012C71.844 163.091 85.5035 206.317 74.1991 225.506C62.8947 244.694 58.0079 229.632 56.9776 219.703C39.6678 223.726 35.3403 213.126 35.3403 207.323C10.9653 215.37 8.9929 197.006 11.0536 186.819Z",
    fill: "#440919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 142",
    d: "M57.9549 152C27.6167 156.04 23.0659 193.911 62 203L57.9549 152Z",
    fill: "#FEC7A9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 143",
    filter: "url(#filter2_d_435_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.611 61.543C60.1316 61.543 49.3086 144.586 60.1316 186.108C60.1316 251.066 86.6145 283.556 170.611 283.556C243.99 283.556 273.079 257.669 273.079 186.108C284.042 158.144 273.079 61.543 170.611 61.543Z",
    fill: "#FEC7A9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 33",
    d: "M189.909 226.281C189.909 223.356 187.536 220.963 184.534 220.773C171.812 226.258 164.412 228.37 148.057 220.773C145.055 220.963 142.682 223.356 142.682 226.281C142.682 229.206 145.055 231.6 148.057 231.789C165.981 241.931 172.473 237.81 184.534 231.789C187.536 231.6 189.909 229.206 189.909 226.281Z",
    fill: "#F26D5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 144",
    d: "M167.11 164.849C148.551 197.945 156.044 198.784 167.11 202.557C178.074 199.167 185.243 196.625 167.11 164.849Z",
    fill: "#F26D5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 145",
    d: "M127.604 32.4253C81.3778 31.2565 60.3791 81.1608 8.51917 136.242C5.45236 139.499 7.76791 145.061 12.239 145.254C46.7646 146.74 62.7363 154.259 130.047 123.341C164.329 107.594 189.889 93.9864 189.371 74.7144C188.412 39.0688 152.709 33.0602 127.604 32.4253Z",
    fill: "#440919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 146",
    d: "M251.336 48.3387C222.336 15.3274 157.915 35.9106 163.175 65.4267C173.835 125.235 243.474 144.783 276.47 160.577C285.44 161.82 290.519 169.121 291.937 172.616C297.814 192.811 281.239 200.449 272.216 201.744C274.072 205.472 269.123 225.564 266.416 235.143C283.12 236.076 285.234 220.774 286.523 213.395C306.321 222.716 310.239 209.511 309.723 201.744C343.132 208.268 340.142 180.125 334.47 165.237C333.31 160.965 297.844 101.28 251.336 48.3387Z",
    fill: "#440919"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 34",
    cx: 19.7354,
    cy: 29.1673,
    rx: 19.7354,
    ry: 29.1673,
    transform: "matrix(0.907456 -0.420146 0.417123 0.90885 63.4741 184.513)",
    fill: "#F26D5B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 35",
    cx: 19.7372,
    cy: 29.1647,
    rx: 19.7372,
    ry: 29.1647,
    transform: "matrix(-0.896268 -0.443513 -0.440399 0.897802 271.03 185.463)",
    fill: "#F26D5B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eyes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 147",
    d: "M247.941 181.286H193.123C187.219 144.001 196.56 133.686 215.05 132.138C245.411 129.595 258.225 162.876 247.941 181.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pupil"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-1_435_310",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.385 162.728C194.407 167.195 198.235 177.151 200.272 181.571H228.371C234.235 170.963 233.045 159.239 228.371 153.656C217.62 140.815 205.158 146.798 200.272 152.149C223.327 164.013 213.554 167.502 195.385 162.728Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.385 162.728C194.407 167.195 198.235 177.151 200.272 181.571H228.371C234.235 170.963 233.045 159.239 228.371 153.656C217.62 140.815 205.158 146.798 200.272 152.149C223.327 164.013 213.554 167.502 195.385 162.728Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-24-inside-1_435_310)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eye-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 149",
    d: "M83.4979 181.286H138.316C144.219 144.001 134.878 133.686 116.389 132.138C86.028 129.595 73.2139 162.876 83.4979 181.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pupil"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-26-inside-2_435_310",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.7168 162.728C97.7394 167.195 101.567 177.151 103.604 181.571H131.703C137.567 170.963 136.377 159.239 131.703 153.656C120.952 140.815 108.491 146.798 103.604 152.149C126.659 164.013 116.886 167.502 98.7168 162.728Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.7168 162.728C97.7394 167.195 101.567 177.151 103.604 181.571H131.703C137.567 170.963 136.377 159.239 131.703 153.656C120.952 140.815 108.491 146.798 103.604 152.149C126.659 164.013 116.886 167.502 98.7168 162.728Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-26-inside-2_435_310)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "diadem"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 75_2",
    filter: "url(#filter3_d_435_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109 72H224V110.581L166.5 124L109 110.581V72Z",
    fill: "#EFCC3C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Star 2",
    d: "M166.5 78L171.937 89.0166L184.095 90.7832L175.297 99.3584L177.374 111.467L166.5 105.75L155.626 111.467L157.703 99.3584L148.905 90.7832L161.063 89.0166L166.5 78Z",
    fill: "#F73308"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "arms"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arm-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 72",
    d: "M23 335.807C23 309.404 44.4038 288 70.8066 288C73.4469 288 75.5873 290.14 75.5873 292.781V418.929C75.5873 421.69 73.3487 423.929 70.5873 423.929H28C25.2386 423.929 23 421.69 23 418.929V335.807Z",
    fill: "#FEC7A9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 73",
    filter: "url(#filter4_d_435_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 356H76V419C76 421.761 73.7614 424 71 424H28C25.2386 424 23 421.761 23 419V356Z",
    fill: "#EFCC3C"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "hand-1",
    cx: 50.8401,
    cy: 449.561,
    rx: 21.6536,
    ry: 21.7486,
    fill: "#FEC7A9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arm-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 70",
    d: "M306.587 335.807C306.587 309.404 285.184 288 258.781 288C256.14 288 254 290.14 254 292.781V418.929C254 421.69 256.239 423.929 259 423.929H301.587C304.349 423.929 306.587 421.69 306.587 418.929V335.807Z",
    fill: "#FEC7A9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 71",
    filter: "url(#filter5_d_435_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254 356H306V419C306 421.761 303.761 424 301 424H259C256.239 424 254 421.761 254 419V356Z",
    fill: "#EFCC3C"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "hand-2",
    cx: 279.52,
    cy: 449.561,
    rx: 21.6536,
    ry: 21.7486,
    fill: "#FEC7A9"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_435_310",
    x: 71,
    y: 286,
    width: 188,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.572549 0 0 0 0 0.407843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_435_310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_435_310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_435_310",
    x: 61,
    y: 446,
    width: 207.5,
    height: 79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_435_310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_435_310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_435_310",
    x: 51.8408,
    y: 57.543,
    width: 229.635,
    height: 232.014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878733 0 0 0 0 0.574098 0 0 0 0 0.407933 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_435_310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_435_310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_435_310",
    x: 105,
    y: 72,
    width: 123,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_435_310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_435_310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_435_310",
    x: 19,
    y: 348,
    width: 61,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.572549 0 0 0 0 0.407843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_435_310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_435_310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_435_310",
    x: 250,
    y: 348,
    width: 60,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.572549 0 0 0 0 0.407843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_435_310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_435_310",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterWonder);
export default __webpack_public_path__ + "static/media/character-wonder.0b643048b980ac3c2803dd2c7de7a54d.svg";
export { ForwardRef as ReactComponent };